import { ItemRestraints } from '@core/shared/restraints';
export class MediaAssetRestraints extends ItemRestraints {
  canViewItem(item) {
    return true;
  }
  canCreateItem(item) {
    return this.requireRole('ADMINISTRATOR');
  }
  canToggleItem(item) {
    return false;
  }
  canUpdateItem(item, oldItem) {
    return this.requireRole('ADMINISTRATOR');
  }
  canRemoveItem(item) {
    return this.requireRole('ADMINISTRATOR');
  }
}